import { __generator } from "tslib";
import { take, all, takeLatest, call } from 'redux-saga/effects';
import { request } from '../../../xhr';
import { isApiError } from '../../../xhr/request';
import { addMediaToTier, reduxModuleLoaded } from './actions';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'server_error',
                errorDescription: 'Could not create asset',
                status: 'error',
            };
        }
        return {
            success: true,
        };
    }
}
function handleAddMediaToTier(action) {
    var data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    tier_deviationid: action.payload.tierDeviation.deviationId,
                    deviationids: action.payload.deviations.map(function (d) { return d.deviationId; }),
                };
                return [4 /*yield*/, call(request, {
                        url: '/tier/deviation/add',
                        method: 'post',
                        data: data,
                    }, fakeResponse)];
            case 1:
                response = _a.sent();
                if (!response) {
                    // TODO error handling
                    alert('oh no we messed up...');
                    return [2 /*return*/];
                }
                if (isApiError(response)) {
                    // TODO error handling
                    alert('oh no we messed up...');
                    return [2 /*return*/];
                }
                // TODO specs for success handling
                window.location.reload();
                return [2 /*return*/];
        }
    });
}
export default function dasSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent(); // wait for redux to load
                return [4 /*yield*/, all([takeLatest(addMediaToTier, handleAddMediaToTier)])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=tierManageContentSaga.js.map